import React, { useRef } from 'react';
import { s as styles } from '../url-input-modal-018415d9.js';
import '../style-inject.es-746bb8ed.js';

const MediaUploadModal = ({
  id,
  handleClick,
  handleChange,
  languageDir,
  title,
  labelText,
  dataHook,
  showUploadSection,
  accept
}) => {
  const inputRef = useRef(null);
  const onChange = (e) => handleChange(e.target.files[0]);
  const onKeyPress = (e) => {
    var _a;
    return e.key === "Enter" && ((_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.click());
  };
  const uploadSection = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.mediaUploadModal }, /* @__PURE__ */ React.createElement(
    "label",
    {
      htmlFor: id,
      className: styles.mediaUploadModal_fileInputLabel,
      role: "button",
      "data-hook": dataHook,
      onKeyPress,
      tabIndex: 0
    },
    /* @__PURE__ */ React.createElement(
      "input",
      {
        id,
        type: "file",
        accept,
        className: styles.mediaUploadModal_fileInput,
        ref: inputRef,
        onClick: handleClick,
        onChange,
        tabIndex: -1
      }
    ),
    labelText
  )));
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.header_subTitle, dir: languageDir }, title), showUploadSection && uploadSection);
};

export { MediaUploadModal as default };
//# sourceMappingURL=MediaUploadModal.js.map
